import {
    decodeProtocol,
    encodeProtocol
} from './lube/Client';
import {
    isIos,
    isNative,
    redirect,
    format,
    getUrlStrs,
    deFormat,
    getEnv,
    isSimulatorEnv,
    isVersionMoreThanOrEqualTo
} from './utils';
import { bridge } from './bridge';
import { registerBroadcast } from './BroadCast';
import { BOM } from './BOM';
import { GameLog } from './Game';
/*
* 此列表内的协议会用于页面初始化的的调用，
* 防止相关的行为在app外部造成跳转至下载页的行为
* */
const REDIRECTBLOCKLIST = [
    'update_back_gesture',
    'update_reload_options',
    'pageloaded',
    'update_right_button',
    'update_back_button',
    'close_bottom_bar',
    'is_in_screen',
    'set_page_id',
    'update_player_style',
    'soft_change',
    'purchase_success',
    'update_screen_id',
    'update_user'
];
/*
* 试用于两端新协议的定义（安卓不再兼容androidObj）
* */
const NEWANDROIDPROTOCOLLIST = [
    'chat_detail',
    'report',
    'soft_change',
    'liveroom',
    'request',
    'add_to_calendar',
    'check_calendar',
    'gift_rank_send',
    'purchase_success',
    'input_text',
    'sudgame',
    'custom_alert',
    'qr_scan',
    'singer_privilege_exposure',
    'avatargashupon_rewards',
    'preview_video',
    'get_config_vars',
    'liveroom_gift',
    'update_property_get',
    'update_user',
    'gift_lottery_select_coin_count',
    'pet_exp_change',//宠物经验值变化
    'pet_selected_change'//宠物变化
];

//封装非 androidObj.call 外的安卓协议调用(旧协议)
function wrapAndroid(name, params = '') {
    if (!BOM.window.androidObj) {
        BOM.log(name + '(' + params + ')');
        return;
    }
    if (params) {
        BOM.window.androidObj[name](params);
    } else {
        BOM.window.androidObj[name]();
    }
}

//仅安卓
function formatAndroid(param) {
    let s = [];
    const _toString = Object.prototype.toString;
    for (let j in param) {
        let data = param[j];
        if (
            _toString.call(data) === '[object Object]' ||
            _toString.call(data) === '[object Array]'
        ) {
            data = JSON.stringify(data);
        }
        s.push(encodeURIComponent(j) + '=' + encodeURIComponent(data));
    }
    const final = s.join('&');
    if (final === '') {
        return '';
    } else {
        return '?' + final;
    }
}

/*
封装协议
name :名称
params:参数
iosCallBack: 是否基于回调注册方式，否的话基于全局函数
*/
function createProtocol(name, params = {}, iosCallBack = false) {
    if (!isNative()) {
        if (REDIRECTBLOCKLIST.indexOf(name) != -1) {
            return;
        }
        redirect();
    }
    if (isIos() || NEWANDROIDPROTOCOLLIST.indexOf(name) != -1) {
        //针对ios自己的回调函数写法
        if (iosCallBack) {
            bridge.post(
                name,
                {
                    ...params
                },
                (parameters, error) => {
                    //callback关键字
                    BOM.window[params.callback](parameters, error);
                },
                params.print || 0,
                params.allowMultipleCallback || false
            );
        } else {
            bridge.post(name, {
                ...params
            });
        }
    } else {
        const protocol = 'local://' + name + formatAndroid(params);
        if (!BOM.window.androidObj) {
            BOM.log(protocol);
            return;
        }
        BOM.window.androidObj.call(protocol);
    }
}

/*
*废弃
*只用于兼容之前的对外引用
* */
function createProtocol2(name, params = {}, callback = false) {
    //后期兼容了 createProtocol
    createProtocol(name, params, callback);
}

/*
*协议解析(只用于没有回调的情况)
* open_url: 内容 例 :local://mv?mv_id=123
* num_type: 对number类型进行解析时，可以解成string,为了兼容ios旧版本
 */
function openUrl(open_url, num_type) {
    if (isSimulatorEnv()) return;
    let _num_type = num_type || 0; //0 int 1 string
    let params = getUrlStrs();
    try {
        if (!isNative()) {
            let hit = REDIRECTBLOCKLIST.filter(v => {
                return open_url.split('?')[0].indexOf(v) != -1;
            });
            if (hit.length > 0) {
                return;
            }
            redirect();
        }
        let _hasQueryString = open_url.indexOf('?') != -1;
        if (params.event_refer_json) {
            if (_hasQueryString) {
                open_url = open_url + '&event_refer_json=' + params.event_refer_json;
            } else {
                open_url = open_url + '?event_refer_json=' + params.event_refer_json;
            }
        }
        const newProtocolHit = NEWANDROIDPROTOCOLLIST.filter(v => {
            return open_url.split('?')[0].indexOf(v) != -1;
        });
        if (isIos() || newProtocolHit.length > 0) {
            //let open_url='local://bind?platform=phone'
            let result;
            let re;
            if (!_hasQueryString && !params.event_refer_json) {
                re = new RegExp('//(.+)', 'g');
                result = re.exec(open_url);
                if (result) {
                    bridge.post(result[1]);
                }
            } else {
                re = new RegExp('//(.+)\\?([\\s\\S]+)', 'g');
                result = re.exec(open_url);
                if (result) {
                    let p = deFormat(result[2], _num_type);
                    bridge.post(result[1], p);
                }
            }
        } else {
            if (!BOM.window.androidObj) {
                BOM.log(open_url);
                return;
            }
            BOM.window.androidObj.call(open_url);
        }
    } catch (e) {
        BOM.log(e);
    }
}

/*
*举报
 */
function report(type, parameters, callbackName = 'callback') {
    if (!type || !parameters) return;
    createProtocol2(
        'report',
        {
            type,
            parameters,
            callback: callbackName
        },
        true
    );
}

/*
*     window.pickImageCallBack = function(parameters, error) {
            if (error) {
                alert('pick_image error' + error.code);
            }
            if (parameters) {
                const img = document.getElementById('pick_image_wrapper');
                img.src = parameters.url;
            }
        }
*
*
* */

//选择客户端图片
function pickImage(params, callBackName = 'pickImageCallBack') {
    const p = getUrlStrs();
    let crop_ratio = 0.5;
    const h = parseInt(p.screen_height);
    const w = parseInt(p.screen_width);
    if (!isNaN(h) && !isNaN(w)) {
        crop_ratio = parseFloat((w / h).toFixed(1));
    }
    createProtocol(
        'pick_image',
        {
            crop_ratio: crop_ratio,
            gif_supported: 1,
            max_length: 1080,
            source_types: ['photo', 'camera'],
            callback: callBackName,
            ...params
        },
        true
    );
}

//预览图片
//items:[{ urls:["https://cdn.pokekara.com/sp1/pokekara/jpg/large/7e/5e/7e410fea82e92f600ce5a2334f40475e_750-750-0.jpg"]} ]
function preview(items, defaultIndex = 0) {
    createProtocol('preview_image', {
        items: items,
        default_index: defaultIndex
    });
}

//注册客户端关闭按钮事件(会阻断客户单的关闭行为)
function registerCloseButtonEvent(callBackFunctionName, disAbleGesture = true) {
    createProtocol('update_back_button', {
        callback: callBackFunctionName,
        extra: { callback_id: 1 }
    });
    if (disAbleGesture) {
        createProtocol('update_back_gesture', {
            enabled: 0,
            edge_margin: 0
        });
    }
}

//注册客户端自定义按钮事件（右上角按钮）
function registerButtonCallBackEvent(text, callback) {
    createProtocol('update_right_button', {
        type: 3,
        text: text,
        callback: callback,
        enabled: 1
    });
}

//注册客户端自定义按钮事件（右上角按钮）
function registerButtonCallBackEventV2(text, icon, callback, can_render = 0) {
    createProtocol('update_right_button', {
        type: 3,
        text: text,
        icon: icon,
        callback: callback,
        can_render: can_render,
        enabled: 1
    });
}

//调用客户端评论
function comment(params, callback) {
    if (!params.hasOwnProperty('comment_type') || !params.hasOwnProperty('comment_to')) {
        BOM.log('comment_type and comment_to required');
        return;
    }
    createProtocol('comment', {
        callback: callback,
        ...params
    });
}

/*
初始化站内分享(只有dm)
例:
* configShareDmButton({
      url:"abc",
      title:"a",
      message:'tt',
      icon_url:'a.png',
      extra:{ 'activity_id':'123' }
* })
* */
function configShareDmButton(dmInfo) {
    const data = {
        type: 1,
        source_type: 15,
        dm_info: {
            type: 'h5',
            ...dmInfo
        }
    };
    if (dmInfo.extra) {
        data.extra_data = {
            ...dmInfo.extra,
            extra: dmInfo.extra
        };
        data.extra_data = JSON.stringify(data.extra_data);
    }
    if (dmInfo.calendar) {
        const _calendar = { ...dmInfo.calendar };
        _calendar.open_url = 'pokekara://webview?url=' + encodeURIComponent(_calendar.open_url);
        data.calendar = JSON.stringify(_calendar);
    }
    data.dm_info.url && (data.dm_info.url = encodeURIComponent(data.dm_info.url));
    data.dm_info = JSON.stringify(data.dm_info);
    openUrl('local://update_right_button?' + format(data, false));
}

/*
 *展示底部分享dm面板
 * 例:
 mv
showDmShareView({
  type:"mv",
  source_id:"123456"
 })
h5
showDmShareView({
  type:"h5",
  url:"abc",
  title:"a",
  message:'tt',
  icon_url:'a.png',
  extra:{ 'activity_id':'123' }
 })
 */
function showDmShareView(dmInfo) {
    const data = {
        dm_info: {
            type: 'h5',
            ...dmInfo
        }
    };
    if (data.dm_info.type === 'h5') {
        data.source_type = 15;
    } else if (data.dm_info.type === 'mv') {
        data.source_type = 0;
    }
    if (dmInfo.extra) {
        data.extra_data = {
            ...dmInfo.extra,
            extra: dmInfo.extra
        };
        data.extra_data = JSON.stringify(data.extra_data);
    }
    data.dm_info.url && (data.dm_info.url = encodeURIComponent(data.dm_info.url));
    data.dm_info = JSON.stringify(data.dm_info);
    openUrl('local://show_share_view?' + format(data, false));
}

/*
*查询当前webview是否可见
* */
function triggerInScreenCallBack() {
    createProtocol(
        'is_in_screen',
        {
            callback: 'is_in_screen'
        },
        true
    );
}

//触发客户端登录
function clientLogin(confirmBeforeLogin) {
    const _confirmBeforeLogin = confirmBeforeLogin || false;
    if (!isNative()) {
        redirect();
        return;
    }
    try {
        if (_confirmBeforeLogin) {
            openUrl('local://login?forward=refresh&confirm_before_login=1');
            return;
        }
        openUrl('local://login?forward=refresh');
    } catch (e) {
        BOM.log(e);
    }
}

/*
 * 展示右上角分享按钮（仅支持h5）
 * 例
* configShareButton({
      content:"abc",
      title:"a",
      activity_id:'tt',
      dm_info:{ icon_url:'a.png' }
* })
* */
function configShareButton(shareObj) {
    let _shareObj = {
        //content
        //fb_content
        //copy_content
        //tw_content
        //sys_content
        //line_content
        //title
        //extra_data
        //url
        //dm_info
        //calendar
    };
    for (let o in shareObj) {
        _shareObj[o] = shareObj[o];
    }
    if (
        (!_shareObj.title || _shareObj.title === '') &&
        (!_shareObj.content || _shareObj.content === '')
    ) {
        return;
    }
    if (!_shareObj.extra_data) {
        _shareObj.extra_data = {
            activity_id: _shareObj.activity_id || 'none'
        };
    }
    if (!_shareObj.url) {
        let pro = getEnv() === 'cdn' ? 'https://u.pokekara.com/s/' : 'http://test.pokekara.com/s/';
        _shareObj.url = pro + _shareObj.extra_data.activity_id;
    }
    if (!_shareObj.copy_content) {
        _shareObj.copy_content = (_shareObj.content || '') + _shareObj.url;
    }
    if (!_shareObj.line_content && !isIos()) {
        _shareObj.line_content = (_shareObj.content || '') + _shareObj.url;
    }
    if (_shareObj.dm_info) {
        _shareObj.dm_info.type = 'h5';
        !_shareObj.dm_info.url && (_shareObj.dm_info.url = encodeURIComponent(_shareObj.url));
        !_shareObj.dm_info.title && (_shareObj.dm_info.title = _shareObj.title);
        !_shareObj.dm_info.message && (_shareObj.dm_info.message = _shareObj.content || '');
        !_shareObj.dm_info.extra && (_shareObj.dm_info.extra = _shareObj.extra_data);
    }
    _shareObj.type = 1;
    _shareObj.source_type = 15;
    _shareObj.extra_data.extra = { ..._shareObj.extra_data };
    _shareObj.extra_data && (_shareObj.extra_data = JSON.stringify(_shareObj.extra_data));
    if (_shareObj.calendar) {
        const _calendar = { ..._shareObj.calendar };
        _calendar.open_url = 'pokekara://webview?url=' + encodeURIComponent(_calendar.open_url);
        _shareObj.calendar = JSON.stringify(_calendar);
    }
    _shareObj.dm_info && (_shareObj.dm_info = JSON.stringify(_shareObj.dm_info));
    openUrl('local://update_right_button?' + format(_shareObj, false));
}

/*
 * 弹出分享面板
 支持h5 与mv
 */

/* mv
showShareView({
  source_type:0,
  source_id:"123456"
 })
h5
showShareView({
  source_type:15,
  content:"abc",
  title:"a",
  activity_id:'tt',
  dm_info:{ icon_url:'a.png' }
 })
 */
function showShareView(shareObj) {
    let _shareObj = {
        //source_type
        //source_id
        //content
        //fb_content
        //copy_content
        //tw_content
        //sys_content
        //line_content
        //title
        //extra_data
        //url
        //dm_info:{
        //source_id
        //type
        //message
        //extra
        //title
        //icon_url
        //url
        //}
    };
    for (let o in shareObj) {
        _shareObj[o] = shareObj[o];
    }
    if (!_shareObj.extra_data) {
        _shareObj.extra_data = {
            activity_id: _shareObj.activity_id || 'none'
        };
    }
    if (!_shareObj.url) {
        let pro = getEnv() === 'cdn' ? 'https://u.pokekara.com/s/' : 'http://test.pokekara.com/s/';
        _shareObj.url = pro + _shareObj.extra_data.activity_id;
    }
    if (!_shareObj.copy_content) {
        _shareObj.copy_content = (_shareObj.content || '') + _shareObj.url;
    }
    if (!_shareObj.line_content && !isIos()) {
        _shareObj.line_content = (_shareObj.content || '') + _shareObj.url;
    }
    //h5
    if (_shareObj.source_type === 15) {
        if (_shareObj.dm_info) {
            _shareObj.dm_info.type = 'h5';
            !_shareObj.dm_info.url && (_shareObj.dm_info.url = encodeURIComponent(_shareObj.url));
            !_shareObj.dm_info.title && (_shareObj.dm_info.title = _shareObj.title);
            !_shareObj.dm_info.message && (_shareObj.dm_info.message = _shareObj.content || '');
            !_shareObj.dm_info.extra && (_shareObj.dm_info.extra = _shareObj.extra_data);
        }
        //mv
    } else if (_shareObj.source_type === 0) {
        if (!_shareObj.dm_info) {
            _shareObj.dm_info = {};
        }
        _shareObj.dm_info.type = 'mv';
        _shareObj.dm_info.source_id = _shareObj.source_id;
    }
    _shareObj.extra_data.extra = { ..._shareObj.extra_data };
    _shareObj.extra_data && (_shareObj.extra_data = JSON.stringify(_shareObj.extra_data));
    _shareObj.dm_info && (_shareObj.dm_info = JSON.stringify(_shareObj.dm_info));
    openUrl('local://show_share_view?' + format(_shareObj, false));
}


//关闭webview
function closeWebview(page_ids = []) {
    if (!isNative()) {
        BOM.log('close_web_view_called');
        return;
        //redirect();
    }
    if (GameLog.instance) {
        GameLog.instance.reportLoadFailTime();
    }
    if (isIos()) {
        bridge.post('close', { page_ids });
    } else {
        setTimeout(() => {
            wrapAndroid('close', JSON.stringify({ page_ids }));
        }, 0);
    }
}

//统计
function trackServer(data) {
    if (!isNative()) return;
    const _data = {
        event: '',
        label: '',
        value: '',
        extra: {},
        ...data
    };
    if (_data.extra.length) {
        _data.extra = JSON.parse(_data.extra);
    }
    const _params = getUrlStrs();
    if (_params.event_refer_json) {
        const _extra = JSON.parse(decodeURIComponent(_params.event_refer_json));
        _data.extra = {
            ..._data.extra,
            ..._extra
        };
    }
    _data.extra = JSON.stringify(_data.extra);
    openUrl('local://track_server?' + format(_data));
}

/*
* 统计友盟
* */
function trackUmeng(data) {
    if (!isNative()) return;
    const _data = {
        event: '',
        label: '',
        ...data
    };
    openUrl('local://track_umeng?' + format(_data));
}

//写客户端缓存
function writeKeyChain(keyChain) {
    if (!isNative()) return;
    if (!isIos()) {
        wrapAndroid('write_keychain', JSON.stringify(keyChain));
    } else {
        bridge.post('write_keychain', keyChain);
    }
}

//弹窗录音面板
//客户端返回数据格式
//{ "url":"http://xxx.mp3", "duration":10 }
function record(params, callBackName) {
    createProtocol(
        'record',
        {
            minimum_duration: 10,
            maximum_duration: 60,
            start_immediately: false,
            callback: callBackName,
            ...params
        },
        true
    );
}

let loadBillingDataLoaded = false;

//调起客户端购买gold面板
// 增加安卓与客户端数据区分, 做老数据兼容
async function purchase(type, item_Params, callBackName = 'directPurchaseCallback') {
    let item_id = {
        ios: 'pokekara_ios_new_',
        android: 'pokekara_android_new_'
    };
    if (item_Params) {
        if (item_Params.constructor == String || item_Params.constructor == Number) {
            item_id = {
                ios: item_id.ios + item_Params,
                android: item_id.android + item_Params,
            };
        } else {
            item_id = {
                ios: item_Params.ios || 'pokekara_ios_new_0',
                android: item_Params.android || 'pokekara_android_new_0'
            };
        }
    } else {
        item_id = {
            ios: 'pokekara_ios_new_0',
            android: 'pokekara_android_new_0'
        };
    }
    if (isIos()) {
        if (type === 'coin') item_id = item_id.ios;
    } else {
        if (type === 'coin') item_id = item_id.android;
    }
    if (!isIos() && !loadBillingDataLoaded) {
        wrapAndroid('loadBillingData');
        loadBillingDataLoaded = true;
        await new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 500);
        });
    }
    createProtocol(
        'direct_purchase',
        {
            type: type,
            item_id: item_id,
            callback: callBackName
        },
        true
    );
}

function loadAndroidBillingData() {
    if (!isIos()) {
        wrapAndroid('loadBillingData');
    }
}

//添加日历
function addToCalendar(calendar, callBackName) {
    const _calendar = { ...calendar };
    _calendar.open_url = 'https://www.pokekara.com/app/universal/webview?url=' + encodeURIComponent(_calendar.open_url);
    createProtocol(
        'add_to_calendar',
        {
            ..._calendar,
            callback: callBackName
        },
        true
    );
}

//查询是否已经添加
function checkCalendar(id, callBackName) {
    createProtocol(
        'check_calendar',
        {
            id: id,
            callback: callBackName
        },
        true
    );
}

//webview右上角日历按钮
function configCalendarButton(calendar) {
    const _calendar = { ...calendar };
    _calendar.open_url = encodeURIComponent('https://www.pokekara.com/app/universal/webview?url=' + encodeURIComponent(_calendar.open_url));
    openUrl('local://update_right_button?calendar=' + JSON.stringify(_calendar));
}

//webview打开未知url
function openWebView(url) {
    if (!url) return;
    if (/local:\/\//.test(url)) {
        //处理url未encode
        if (isIos() && url.split('?').length >= 3) {
            const url = url.replace('local://webview?url=', '');
            bridge.post('webview', {
                url: url
            });
        } else {
            openUrl(url);
        }
    } else {
        if (isNative()) {
            //处理未添加本地协议
            if (!/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(url)) {
                return;
            }
            openUrl('local://webview?url=' + encodeURIComponent(url));
        } else {
            if (isSimulatorEnv()) return;
            BOM.window.open(url);
        }
    }
}

// 打开客户端输入框，
// type: 输入框类型，包含 text/number, 默认 text。number 为浮点型数
// max_length	当输入文本为 text 时生效，表示最大允许输入字数
// max/min	当输入类型为 number 是，最大/最小允许输入值
// placeholder	占位字符
// content	默认值
// callback 回调方法，window全局
function openClientNormalInput(params) {
    createProtocol('input_text', params, true);
}

//注册页面重新出现事件
//@funcName 是全局函数名，需要注册到window上
function registerPageReAppearEvent(funcName) {
    registerBroadcast({
        func_name: funcName,
        name: 'app.appear'
    });
}

/*
读取客户端配置(pokeUser补充字段)
keys:'key1,key2'
result :{ 'key1':'', 'key2':'' }
字段来源:
https://api.pokekara.com/x/config/vars?appid=com.maetimes.ios.Karaoke&phonetype=android&v=3.1
*/
function getGlobalConfigFromClient(keys) {
    return new BOM.window.Promise((resolve) => {
        const params = getUrlStrs();
        const version = isIos() ? '3.4.23' : '3.4.47';
        if (isNative() && isVersionMoreThanOrEqualTo(params.v, version)) {
            bridge.post('get_config_vars', {
                fields: keys
            }, (result, error) => {
                if (error) {
                    resolve(null);
                } else {
                    resolve(result);
                }
            });
        } else {
            resolve(null);
        }
    });
}

export {
    createProtocol,
    report,
    pickImage,
    preview,
    registerCloseButtonEvent,
    registerButtonCallBackEvent,
    wrapAndroid,
    comment,
    configShareDmButton,
    showDmShareView,
    triggerInScreenCallBack,
    createProtocol2,
    openUrl,
    clientLogin,
    configShareButton,
    showShareView,
    closeWebview,
    trackServer,
    trackUmeng,
    writeKeyChain,
    record,
    purchase,
    loadAndroidBillingData,
    decodeProtocol,
    encodeProtocol,
    addToCalendar,
    checkCalendar,
    configCalendarButton,
    registerButtonCallBackEventV2,
    openWebView,
    openClientNormalInput,
    registerPageReAppearEvent,
    getGlobalConfigFromClient
};
